// ===== SHARED SIDEBAR COLOR SYSTEM =====
export const sidebarColors = {
  light: {
    wrapperBg: "#f1f1f1ff",
    sidebarBg: "rgba(255, 255, 255, 0.95)",
    sidebarBorder: "rgba(0, 0, 0, 0.08)",
    text: "#0f172a",
    textSecondary: "#64748b",
    navHover: "rgba(59, 130, 246, 0.08)",
    navActive: "linear-gradient(135deg, #2e7cba, #2e7cba)",
    topbarBg: "rgba(255, 255, 255, 0.95)",
    contentBg: "transparent",
    inputBg: "rgba(248, 250, 252, 0.8)",
    inputBorder: "rgba(0, 0, 0, 0.12)",
    shadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
    glassEffect: "blur(16px)",
    notificationBg: "rgba(255, 255, 255, 0.98)",
    notificationShadow: "0 20px 60px rgba(0, 0, 0, 0.15)",
    modalBg: "rgba(255, 255, 255, 0.98)",
    modalOverlay: "rgba(0, 0, 0, 0.4)",
    userProfileBg: "rgba(255, 255, 255, 0.98)",
    userProfileShadow: "0 20px 60px rgba(0, 0, 0, 0.15)",
    // Topbar user menu
    menuRing: "#ffffff",
    accentSoft: "rgba(46, 124, 186, 0.10)",
    accentSoftHover: "rgba(46, 124, 186, 0.16)",
    accentBorder: "rgba(46, 124, 186, 0.35)",
    danger: "#dc2626",
    dangerSoft: "rgba(239, 68, 68, 0.08)",
    statusOnline: "#22c55e",
    statusOffline: "#94a3b8",
    statusAway: "#f59e0b",
    statusBusy: "#ef4444",
    scrollTrack: "rgba(249, 250, 251, 0.8)",
    scrollThumb:
      "linear-gradient(135deg, rgba(59, 130, 246, 0.3), rgba(99, 102, 241, 0.2))",
    scrollThumbHover:
      "linear-gradient(135deg, rgba(59, 130, 246, 0.5), rgba(99, 102, 241, 0.4))",
    scrollThumbActive:
      "linear-gradient(135deg, rgba(59, 130, 246, 0.7), rgba(99, 102, 241, 0.6))",
  },
  dark: {
    wrapperBg: "rgba(15, 23, 42, 0.95)",
    sidebarBg: "rgba(15, 23, 42, 0.95)",
    sidebarBorder: "rgba(255, 255, 255, 0.08)",
    text: "#ffffff",
    textSecondary: "rgba(255, 255, 255, 0.7)",
    navHover: "rgba(255, 255, 255, 0.08)",
    navActive: "linear-gradient(135deg, #2e7cba, #2e7cba)",
    topbarBg: "rgba(15, 23, 42, 0.95)",
    contentBg: "transparent",
    inputBg: "rgba(255, 255, 255, 0.08)",
    inputBorder: "rgba(255, 255, 255, 0.12)",
    shadow: "0 8px 32px rgba(0, 0, 0, 0.4)",
    glassEffect: "blur(16px)",
    notificationBg: "rgba(15, 23, 42, 0.98)",
    notificationShadow: "0 20px 60px rgba(0, 0, 0, 0.6)",
    modalBg: "rgba(15, 23, 42, 0.98)",
    modalOverlay: "rgba(0, 0, 0, 0.6)",
    userProfileBg: "rgba(15, 23, 42, 0.98)",
    userProfileShadow: "0 20px 60px rgba(0, 0, 0, 0.6)",
    // Topbar user menu
    menuRing: "#0f172a",
    accentSoft: "rgba(46, 124, 186, 0.20)",
    accentSoftHover: "rgba(46, 124, 186, 0.30)",
    accentBorder: "rgba(96, 165, 250, 0.45)",
    danger: "#f87171",
    dangerSoft: "rgba(248, 113, 113, 0.12)",
    statusOnline: "#22c55e",
    statusOffline: "#64748b",
    statusAway: "#f59e0b",
    statusBusy: "#ef4444",
    scrollTrack: "rgba(30, 41, 59, 0.6)",
    scrollThumb:
      "linear-gradient(135deg, rgba(99, 102, 241, 0.4), rgba(59, 130, 246, 0.3))",
    scrollThumbHover:
      "linear-gradient(135deg, rgba(99, 102, 241, 0.6), rgba(59, 130, 246, 0.5))",
    scrollThumbActive:
      "linear-gradient(135deg, rgba(99, 102, 241, 0.8), rgba(59, 130, 246, 0.7))",
  },
};

// ===== RESPONSIVE HELPER FUNCTIONS =====
export const getResponsiveBadgeSize = () => {
  const screenWidth = window.innerWidth;
  if (screenWidth <= 480) return 12;
  if (screenWidth <= 768) return 14;
  if (screenWidth <= 1024) return 15;
  return 16;
};

export const getResponsiveFontSizes = (isMobile, isTablet) => {
  return {
    title: isMobile ? "1.125rem" : isTablet ? "1.25rem" : "1.375rem",
    body: isMobile ? "0.875rem" : isTablet ? "0.9375rem" : "0.9375rem",
    small: isMobile ? "0.75rem" : isTablet ? "0.8125rem" : "0.8125rem",
    tiny: isMobile ? "0.6875rem" : "0.75rem",
  };
};

export const getResponsiveSpacing = (isMobile, isTablet) => {
  return {
    padding: isMobile ? "0.75rem" : isTablet ? "1rem" : "1.25rem",
    margin: isMobile ? "0.5rem" : isTablet ? "0.75rem" : "1rem",
    gap: isMobile ? "0.5rem" : isTablet ? "0.75rem" : "1rem",
  };
};

// ===== STYLES SYSTEM =====
// c = sidebarColors[theme]
export const getSidebarStyles = ({
  c,
  theme,
  isRTL,
  isMobile,
  isTablet,
  isCollapsed,
  sidebarOpen,
  showUserProfile,
  fontSizes,
  spacing,
}) => {
  const sidebarWidthPx = isMobile
    ? sidebarOpen
      ? "min(280px, 80vw)"
      : "0"
    : isCollapsed
    ? "4.5rem"
    : isTablet
    ? "18rem"
    : "17.5rem";

  // One compact bar height everywhere (56px phone / 64px tablet+desktop):
  // the old 72–98px bar spent a large share of the viewport on chrome.
  const topbarHeight = isMobile ? "3.5rem" : "4rem";
  // Every topbar control (menu, theme, bell, user chip, clock) shares this
  // square size and radius so the cluster reads as one row.
  const ctl = isMobile ? "2.375rem" : "2.5rem";
  const ctlRadius = "0.625rem";

  return {
    wrapper: {
      display: "flex",
      width: "100%",
      height: "100vh",
      background: c.wrapperBg,
      transition: "all 0.3s ease",
      overflow: "hidden",
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },

    sidebar: {
      position: "fixed",
      left: isRTL ? "auto" : isMobile ? (sidebarOpen ? "0" : "-100%") : "0",
      right: isRTL
        ? isMobile
          ? sidebarOpen
            ? "0"
            : "-100%"
          : "0"
        : "auto",
      top: "0",
      width: sidebarWidthPx,
      height: "100vh",
      background: c.sidebarBg,
      backdropFilter: c.glassEffect,
      border: `1px solid ${c.sidebarBorder}`,
      borderLeft: isRTL ? undefined : "none",
      borderRight: isRTL ? "none" : undefined,
      transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
      zIndex: 1000,
      display: "flex",
      flexDirection: "column",
      boxShadow: c.shadow,
      overflow: "hidden",
      direction: isRTL ? "rtl" : "ltr",
    },

    sidebarHeader: {
      height: topbarHeight,
      minHeight: topbarHeight,
      borderBottom: `1px solid ${c.sidebarBorder}`,
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      gap: 0,
      background: "transparent",
      flexShrink: 0,
      padding: isCollapsed && !isMobile ? "0" : "0 1rem",
      justifyContent: isCollapsed && !isMobile ? "center" : "flex-start",
      overflow: "hidden",
    },

    logo: {
      width: "1.75rem",
      height: "1.75rem",
      position: "relative",
      overflow: "hidden",
      backgroundColor: "transparent",
      flexShrink: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    nav: {
      flex: 1,
      padding: "0.75rem 0",
      overflowY: "auto",
      overflowX: "hidden",
    },

    navItem: {
      display: "flex",
      alignItems: "center",
      justifyContent: isCollapsed && !isMobile ? "center" : "flex-start",
      gap: isCollapsed && !isMobile ? "0" : "0.75rem",
      padding: isCollapsed && !isMobile ? "0" : "0 0.875rem",
      margin:
        isCollapsed && !isMobile ? "0 0.875rem 0.25rem" : "0 0.75rem 0.125rem",
      color: c.textSecondary,
      cursor: "pointer",
      fontSize: "0.875rem",
      fontWeight: "500",
      borderRadius: "0.625rem",
      transition: "background 0.2s ease, color 0.2s ease",
      position: "relative",
      border: "1px solid transparent",
      height: "2.625rem",
      minHeight: "2.625rem",
      overflow: "hidden",
    },

    navItemActive: {
      background: c.navActive,
      color: "white",
      fontWeight: "600",
      boxShadow: "0 2px 8px rgba(46, 124, 186, 0.28)",
      border: "1px solid transparent",
    },

    navItemText: {
      opacity: isCollapsed && !isMobile ? 0 : 1,
      transform:
        isCollapsed && !isMobile ? "translateX(-20px)" : "translateX(0)",
      transition: "all 0.3s ease",
      whiteSpace: "nowrap",
      overflow: "hidden",
    },

    main: {
      flex: 1,
      marginLeft: isRTL ? "0" : isMobile ? "0" : sidebarWidthPx,
      marginRight: isRTL ? (isMobile ? "0" : sidebarWidthPx) : "0",
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      transition: "margin 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
      direction: isRTL ? "rtl" : "ltr",
      position: "relative",
    },

    topbar: {
      background: c.topbarBg,
      backdropFilter: c.glassEffect,
      border: `1px solid ${c.sidebarBorder}`,
      borderTop: "none",
      borderInline: isMobile ? "none" : `1px solid ${c.sidebarBorder}`,
      borderRadius: isMobile ? "0" : "0 0 0.875rem 0.875rem",
      margin: isMobile ? "0" : "0 1rem",
      padding: isMobile ? "0 0.75rem" : isTablet ? "0 1rem" : "0 1.25rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      zIndex: 100,
      boxShadow: "0 1px 2px rgba(0, 0, 0, 0.04), 0 4px 12px rgba(0, 0, 0, 0.04)",
      flexShrink: 0,
      height: topbarHeight,
      minHeight: topbarHeight,
      direction: isRTL ? "rtl" : "ltr",
    },

    content: {
      flex: 1,
      background: c.contentBg,
      padding: isMobile ? spacing.margin : spacing.padding,
      color: c.text,
      transition: "all 0.3s ease",
      overflow: "auto",
      height: `calc(100vh - ${topbarHeight})`,
      position: "relative",
      paddingTop: isMobile ? "0.875rem" : "1.25rem",
    },

    topbarLeft: {
      display: "flex",
      alignItems: "center",
      gap: isMobile ? "0.5rem" : "0.75rem",
      flex: "0 0 auto",
      order: 1,
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    menuBtn: {
      background: c.inputBg,
      border: `1px solid ${c.inputBorder}`,
      color: c.text,
      cursor: "pointer",
      padding: 0,
      width: ctl,
      height: ctl,
      borderRadius: ctlRadius,
      transition: "background 0.2s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    },

    topbarRight: {
      display: "flex",
      alignItems: "center",
      gap: isMobile ? "0.375rem" : "0.5rem",
      color: c.text,
      flex: "0 0 auto",
      order: 2,
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    themeToggle: {
      background: c.inputBg,
      border: `1px solid ${c.inputBorder}`,
      borderRadius: ctlRadius,
      padding: 0,
      width: ctl,
      height: ctl,
      flexShrink: 0,
      cursor: "pointer",
      color: c.text,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "background 0.2s ease",
    },

    // ── Topbar user chip ──────────────────────────────────────────────────
    // Same height (48px desktop / 44px mobile) and corner radius as the
    // theme toggle and notification bell next to it, so the whole cluster
    // reads as one row of controls.
    userInfo: {
      display: "flex",
      alignItems: "center",
      gap: "0.5rem",
      color: c.text,
      height: ctl,
      minWidth: ctl,
      justifyContent: "center",
      paddingBlock: 0,
      paddingInlineStart: isMobile ? 0 : "0.25rem",
      paddingInlineEnd: isMobile ? 0 : "0.625rem",
      borderRadius: ctlRadius,
      cursor: "pointer",
      background: showUserProfile ? c.navHover : c.inputBg,
      border: `1px solid ${showUserProfile ? c.accentBorder : c.inputBorder}`,
      position: "relative",
      userSelect: "none",
    },

    userAvatar: {
      width: isMobile ? "1.75rem" : "1.875rem",
      height: isMobile ? "1.75rem" : "1.875rem",
      borderRadius: "50%",
      objectFit: "cover",
      display: "block",
      position: "relative",
    },

    userAvatarStatus: {
      position: "absolute",
      bottom: "-0.0625rem",
      insetInlineEnd: "-0.0625rem",
      width: "0.5625rem",
      height: "0.5625rem",
      borderRadius: "50%",
      border: `2px solid ${c.menuRing}`,
      background: c.statusOnline,
    },

    userDetails: {
      display: isMobile ? "none" : "flex",
      flexDirection: "column",
      minWidth: 0,
    },

    userName: {
      fontSize: "0.875rem",
      fontWeight: "600",
      color: c.text,
      lineHeight: 1.2,
      maxWidth: "8.5rem",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },

    userDropdownIcon: {
      color: c.textSecondary,
      transition: "transform 0.25s ease",
      transform: showUserProfile ? "rotate(180deg)" : "rotate(0deg)",
      display: isMobile ? "none" : "block",
      flexShrink: 0,
    },

    // ── User menu dropdown ────────────────────────────────────────────────
    // Anchored to the chip (absolute, flush with its outer edge) rather than
    // fixed viewport offsets, so it always opens right under it. Phones keep
    // the full-width sheet under the topbar.
    userProfileDropdown: {
      position: isMobile ? "fixed" : "absolute",
      top: isMobile ? `calc(${topbarHeight} + 0.375rem)` : "calc(100% + 0.5rem)",
      right: isRTL ? "auto" : isMobile ? "0.5rem" : 0,
      left: isRTL ? (isMobile ? "0.5rem" : 0) : "auto",
      width: isMobile ? "calc(100vw - 1rem)" : "20rem",
      padding: "0.5rem",
      background: c.userProfileBg,
      backdropFilter: "blur(1.25rem)",
      border: `1px solid ${c.sidebarBorder}`,
      borderRadius: "1rem",
      boxShadow: c.userProfileShadow,
      zIndex: 1001,
      opacity: showUserProfile ? 1 : 0,
      visibility: showUserProfile ? "visible" : "hidden",
      transform: showUserProfile
        ? "translateY(0) scale(1)"
        : "translateY(-0.375rem) scale(0.98)",
      transformOrigin: isRTL ? "top left" : "top right",
      transition:
        "opacity 0.2s ease, transform 0.25s cubic-bezier(0.16, 1, 0.3, 1), visibility 0.25s",
      maxHeight: "80vh",
      overflowY: "auto",
      direction: isRTL ? "rtl" : "ltr",
      cursor: "default",
    },

    userProfileHeader: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: "0.875rem",
      padding: "0.875rem",
      border: "none",
      borderRadius: "0.75rem",
      background: c.accentSoft,
      color: c.text,
      fontFamily: "inherit",
      textAlign: "start",
      transition: "background 0.15s ease",
    },

    // The whole header (photo + name) opens the viewer's own profile.
    userProfileHeaderButton: {
      cursor: "pointer",
    },

    userProfileAvatar: {
      width: "3.5rem",
      height: "3.5rem",
      borderRadius: "50%",
      objectFit: "cover",
      display: "block",
      flexShrink: 0,
      boxShadow: `0 0 0 3px ${c.menuRing}`,
    },
    userProfileHeaderArrow: {
      color: c.textSecondary,
      flexShrink: 0,
    },

    userProfileIdentity: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      minWidth: 0,
    },

    userProfileName: {
      fontSize: "1rem",
      fontWeight: "700",
      color: c.text,
      lineHeight: 1.3,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },

    userProfileStatus: {
      display: "flex",
      alignItems: "center",
      gap: "0.4375rem",
      marginTop: "0.3125rem",
    },

    userProfileStatusDot: {
      width: "0.5rem",
      height: "0.5rem",
      borderRadius: "50%",
      background: c.statusOnline,
      boxShadow: "0 0 0 3px rgba(34, 197, 94, 0.18)",
      flexShrink: 0,
    },

    userProfileStatusText: {
      fontSize: fontSizes.small,
      color: c.textSecondary,
      fontWeight: "500",
    },

    userProfileContent: {
      paddingTop: "0.5rem",
    },

    userProfileSection: {
      display: "flex",
      flexDirection: "column",
      gap: "0.125rem",
    },

    userProfileSectionTitle: {
      fontSize: fontSizes.tiny,
      fontWeight: "600",
      color: c.textSecondary,
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      padding: "0.375rem 0.5rem 0.25rem",
    },

    userProfileItem: {
      display: "flex",
      alignItems: "center",
      gap: "0.75rem",
      padding: "0.4375rem 0.5rem",
      borderRadius: "0.625rem",
      color: c.text,
      minWidth: 0,
    },

    userProfileItemIcon: {
      width: "2rem",
      height: "2rem",
      borderRadius: "0.625rem",
      background: c.accentSoft,
      color: "#2e7cba",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    },

    userProfileItemText: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      minWidth: 0,
    },

    userProfileItemLabel: {
      fontSize: fontSizes.tiny,
      fontWeight: "500",
      color: c.textSecondary,
      lineHeight: 1.3,
    },

    // Emails and phone numbers are LTR strings even in Arabic — keep their
    // characters in order, but align them with the surrounding RTL text.
    userProfileItemValue: {
      fontSize: fontSizes.small,
      fontWeight: "600",
      color: c.text,
      lineHeight: 1.4,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      direction: "ltr",
      textAlign: isRTL ? "right" : "left",
    },

    userProfileItemValueEmpty: {
      fontWeight: "500",
      color: c.textSecondary,
    },

    userProfileDivider: {
      height: "1px",
      background: c.sidebarBorder,
      margin: "0.5rem 0.25rem",
    },

    // A menu row (not a solid red button) — the red text + tinted icon is
    // enough to mark it as destructive without shouting.
    logoutBtn: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: "0.75rem",
      padding: "0.4375rem 0.5rem",
      border: "none",
      borderRadius: "0.625rem",
      background: "transparent",
      color: c.danger,
      cursor: "pointer",
      fontSize: fontSizes.body,
      fontWeight: "600",
      fontFamily: "inherit",
      textAlign: "start",
      transition: "background 0.15s ease",
    },

    logoutBtnIcon: {
      width: "2rem",
      height: "2rem",
      borderRadius: "0.625rem",
      background: c.dangerSoft,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    },

    switchbtn: {
      background: "linear-gradient(135deg, #2e7cba, #2e7cba)",
      color: "white",
      border: "none",
      padding: isMobile ? "0.75rem 1rem" : "0.75rem 0.955rem",
      borderRadius: isMobile ? "0.75rem" : "9.875rem",
      cursor: "pointer",
      fontSize: fontSizes.body,
      fontWeight: "600",
      display: "flex",
      alignItems: "center",
      gap: "0.625rem",
    },

    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(0, 0, 0, 0.4)",
      zIndex: 999,
      opacity: sidebarOpen && isMobile ? 1 : 0,
      visibility: sidebarOpen && isMobile ? "visible" : "hidden",
      transition: "all 0.3s ease",
      backdropFilter: "blur(0.25rem)",
    },
  };
};

// ===== GLOBAL CSS (injected once by the sidebar) =====
export const getSidebarGlobalCss = ({ c, theme, isMobile, isTablet, isCollapsed }) => {
  // Must mirror the topbarHeight formula in getSidebarStyles above.
  const topbarHeight = isMobile ? "3.5rem" : "4rem";
  return `
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: transparent !important;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  #root {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: transparent !important;
  }

  @keyframes gradientShift {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }

  @keyframes pulse {
    0%, 100% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.15); opacity: 0.8; }
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(0.625rem); }
    to { opacity: 1; transform: translateY(0); }
  }

  @keyframes slideInLeft {
    from { transform: translateX(-100%); }
    to { transform: translateX(0); }
  }

  .menu-btn:hover {
    background: ${c.navHover} !important;
  }

  .collapse-btn:hover {
    background: ${c.navHover} !important;
    transform: scale(1.1) !important;
    box-shadow: 0 0.25rem 0.75rem rgba(59, 130, 246, 0.2) !important;
  }

  .theme-toggle:hover,
  .user-info:hover {
    background: ${c.navHover} !important;
  }

  /* Topbar bell: same flat hover as its neighbours (no scale jump). */
  .notification-bell-btn:hover {
    background: ${c.navHover} !important;
    transform: none !important;
    box-shadow: none !important;
  }

  /* Topbar user menu */
  .user-info:focus-visible,
  .user-menu-header:focus-visible,
  .user-menu-logout:focus-visible {
    outline: 2px solid #2e7cba;
    outline-offset: 2px;
  }

  .user-menu-header:hover {
    background: ${c.accentSoftHover} !important;
  }

  .user-menu-header-arrow {
    transition: transform 0.2s ease;
  }

  .user-menu-header:hover .user-menu-header-arrow {
    transform: translateX(3px);
  }

  html[dir="rtl"] .user-menu-header:hover .user-menu-header-arrow {
    transform: translateX(-3px);
  }

  .user-menu-logout:hover {
    background: ${c.dangerSoft} !important;
  }

  .nav-item:not(.is-active):hover {
    background: ${c.navHover} !important;
    color: ${c.text} !important;
  }

  .nav-item:focus-visible {
    outline: 2px solid #2e7cba;
    outline-offset: 2px;
  }

  /* Hide the nav scrollbar */
  .nav::-webkit-scrollbar {
    display: none !important;
  }

  .nav {
    scrollbar-width: none !important; /* Firefox */
    -ms-overflow-style: none !important; /* IE and Edge */
  }

  /* Page roots (.content > route wrapper > page) too: a page container with
     overflowX hidden becomes a vertical scroll container that shrinks to the
     flex-column wrapper, showing its own bar beside the hidden .content one. */
  .content::-webkit-scrollbar,
  .content > div::-webkit-scrollbar,
  .content > div > *::-webkit-scrollbar,
  .user-profile-dropdown::-webkit-scrollbar {
    display: none !important;
  }

  .content,
  .content > div,
  .content > div > *,
  .user-profile-dropdown {
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }

  @media (max-width: 480px) {
    .user-details {
      display: none !important;
    }
    .date-time-display {
      display: none !important;
    }
    .logout-text {
      display: none !important;
    }
    .user-dropdown-icon {
      display: none !important;
    }
  }

  @media (min-width: 481px) and (max-width: 768px) {
    .user-details {
      display: none !important;
    }
    .date-time-display {
      display: none !important;
    }
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    .date-time-display {
      display: flex !important;
    }
    .user-details {
      display: flex !important;
    }
  }

  .fade-in {
    animation: fadeIn 0.4s ease-out;
  }

  .slide-in-left {
    animation: slideInLeft 0.4s ease-out;
  }

  /* Touch targets. The topbar controls and view-switcher segments are
     sized deliberately (38–40px, with spacing around them), so they are
     left out — forcing 44px on them is what made the bar look bloated. */
  @media (pointer: coarse) {
    button:not(.nx-tb):not(.vts-seg):not(.nx-compact) {
      min-height: 2.75rem !important;
      min-width: 2.75rem !important;
    }
  }

  @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
    .logo img, .user-avatar, .user-profile-avatar {
      image-rendering: -webkit-optimize-contrast;
      image-rendering: crisp-edges;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }

  @media (prefers-color-scheme: dark) {
    :root {
      color-scheme: dark;
    }
  }

  @media (prefers-color-scheme: light) {
    :root {
      color-scheme: light;
    }
  }

  .profile-upload-btn:hover {
    transform: scale(1.1) !important;
    box-shadow: 0 6px 20px rgba(59, 130, 246, 0.6) !important;
  }

  .profile-upload-btn:active {
    transform: scale(0.95) !important;
  }

  .profile-upload-btn:disabled {
    cursor: not-allowed !important;
    opacity: 0.6 !important;
  }

  /* Dynamic-viewport heights: on mobile browsers the URL/tool bars overlay
     part of 100vh, hiding bottom content. Prefer dvh where supported —
     !important because the shell's inline styles set the vh values. */
  @supports (height: 100dvh) {
    html, body, #root { height: 100dvh; }
    .app-shell-root, .app-shell-main { height: 100dvh !important; }
    .app-sidebar { height: 100dvh !important; }
    .content { height: calc(100dvh - ${topbarHeight}) !important; }
  }

  /* Compact topbar controls on small phones so the right cluster
     (switcher + theme + bell + avatar) never overflows the bar. */
  @media (max-width: 400px) {
    .vts-seg { padding: 0 9px !important; }
  }
`;
};
